import Content from "../components/Content/Content";
import { Box, QuickGrid } from "../components/UtilityClasses/UtilityClasses";
import Wrapper from "../components/Wrapper/Wrapper";
import { HashLink } from "react-router-hash-link";
import Button from "../components/Button/Button";

const SummerInfoPage = () => {
  return (
    <>
      <Wrapper id="wp">
        <Content
          titleShow={false}
          columns="1"
          borderColor="green"
          borderWidth="2px"
          borderStyle="solid"
          borderRadius="0 8px"
          contentWidth="90vw"
        >
          <h1>STAR Summer Camp: Western Placer USD</h1>
          <QuickGrid>
            <Box>
              <h4>Traditional Summer Camp Locations:</h4>
              <p>
                <a
                  href="https://goo.gl/maps/N1KBBb3gDHbnxaN78"
                  target="_blank"
                  rel="noreferrer"
                >
                  Lincoln Crossing Elementary (Map)
                </a>{" "}
                | June 10th - August 9th
              </p>
              <h4>Contact</h4>
              <p>
                ph. (916) 409-0797 <br /> email:{" "}
                <a href="mailto:wpcamps@starsacramento.org">
                  wpcamps@starsacramento.org
                </a>
              </p>
              <h4>Hours</h4>
              <p>7:00 AM - 6:00 PM</p>
              <h4>Pricing</h4>
              <p>$55 per day | 2 day per week minimum enrollment</p>
              <h4>Registration</h4>
              <p>Monday, April 8th 9:00 AM</p>
              <p>
                Open to all students in incoming TK-7th grade, regardless of
                previous STAR enrollment
              </p>
              <HashLink smooth to="/summer-preview-wp">
                <Button>Western Placer Summer Calendar</Button>
              </HashLink>
              <a
                href="https://reg.starsacramento.org"
                target="_blank"
                rel="noreferrer"
              >
                <Button>Register</Button>
              </a>
            </Box>
          </QuickGrid>
        </Content>
      </Wrapper>
      <Wrapper id="eu">
        <Content
          titleShow={false}
          columns="1"
          borderColor="purple"
          borderWidth="2px"
          borderStyle="solid"
          borderRadius="0 8px"
          contentWidth="90vw"
        >
          <h1>STAR Summer Camp: Eureka/Loomis USD</h1>
          <QuickGrid>
            <Box>
              <h4>Traditional Summer Camp Locations:</h4>
              <p>
                <a
                  href="https://goo.gl/maps/XPPeMMo93w1ejGsG7"
                  target="_blank"
                  rel="noreferrer"
                >
                  Maidu Elementary (Map)
                </a>{" "}
                | June 10th - July 26th <br />
                <a
                  href="https://goo.gl/maps/ytkssZQ938C4SZhh9"
                  target="_blank"
                  rel="noreferrer"
                >
                  Greenhills Elementary (Map)
                </a>{" "}
                | July 29th - August 9th
              </p>
              <h4>Contact</h4>
              <p>
                Maidu: ph. (916) 782-8454 <br /> Greenhills: ph. (916) 791-8448{" "}
                <br /> email:{" "}
                <a href="mailto:eucamps@starsacramento.org">
                  eucamps@starsacramento.org
                </a>
              </p>
              <h4>Hours</h4>
              <p>6:30 AM - 6:00 PM</p>
              <h4>Pricing</h4>
              <p>$55 per day | 2 day per week minimum enrollment</p>
              <h4>Registration</h4>
              <p>Tuesday, April 9th 9:00 AM</p>
              <p>
                Open to all students in incoming TK-7th grade, regardless of
                previous STAR enrollment
              </p>
              <HashLink smooth to="/summer-preview-eu">
                <Button>Eureka/Loomis Summer Calendar</Button>
              </HashLink>
              <a
                href="https://reg.starsacramento.org"
                target="_blank"
                rel="noreferrer"
              >
                <Button>Register</Button>
              </a>
            </Box>
            <Box>
              <h4>ELO-P Funding</h4>
              <p>
                ELO-P funding is available for all summer camps June 10th - June
                14th and July 8th - August 9th
              </p>
            </Box>
            <Box>
              <h4>ELO-P Summer School Extended Day At Ridgeview</h4>
              <p>
                June 17th - July 3rd | 2:00 - 5:30 PM
                <br />
              </p>
              {/* <HashLink smooth to="/summer-preview-ed">
                <Button>View Extended Day Camps</Button>
              </HashLink> */}
            </Box>
            <Box>
              <h4>Spanish Camp at Maidu</h4>
              <p>June 10th - June 28th | 9:00 AM - 12:00 PM</p>
              <h4>Pricing</h4>
              <p>$200 per week | 5 day enrollment required</p>
              <p>ELO-P funding is not available for this camp</p>
              {/* <HashLink smooth to="/summer-preview-ed">
                <Button>View Spanish Camp</Button>
              </HashLink> */}
            </Box>
          </QuickGrid>
        </Content>
      </Wrapper>
      <Wrapper id="rafos">
        <Content
          titleShow={false}
          columns="1"
          borderColor="blue"
          borderWidth="2px"
          borderStyle="solid"
          borderRadius="0 8px"
          contentWidth="90vw"
        >
          <h1>STAR Summer Camp: Rocklin Academy Family Of Schools</h1>
          <QuickGrid>
            <Box>
              <h4>Traditional Summer Camp Locations:</h4>
              <p>
                <a
                  href="https://goo.gl/maps/2sdrLTPXyN3TdaycA"
                  target="_blank"
                  rel="noreferrer"
                >
                  Rocklin Academy Gateway (Map)
                </a>{" "}
                | June 10th - August 2nd
              </p>
              <h4>Contact</h4>
              <p>
                ph. (916) 303-0003 <br /> email:{" "}
                <a href="mailto:rafoscamps@starsacramento.org">
                  rafoscamps@starsacramento.org
                </a>
              </p>
              <h4>Hours</h4>
              <p>7:00 AM - 6:00 PM</p>
              <h4>Pricing</h4>
              <p>$55 per day | 2 day per week minimum enrollment</p>
              <h4>Registration</h4>
              <p>Wednesday, April 10th 9:00 AM</p>
              <p>
                Open to all students in incoming TK-7th grade, regardless of
                previous STAR enrollment
              </p>
              <HashLink smooth to="/summer-preview-ra">
                <Button>RAFOS Summer Calendar</Button>
              </HashLink>
              <a
                href="https://reg.starsacramento.org"
                target="_blank"
                rel="noreferrer"
              >
                <Button>Register</Button>
              </a>
            </Box>
            <Box>
              <h4>Summer School Extended Day</h4>
              <p>At Gateway and ARCA June 11th - July 3rd</p>
              <h4>Pricing</h4>
              <p>$30 per day | 2 day per week minimum enrollment</p>
              <h4>ELO-P</h4>
              <p>
                ELO-P funding is only available for Summer School Extended Day
              </p>
              {/* <HashLink smooth to="/summer-preview-ed">
                <Button>View Extended Day Camps</Button>
              </HashLink> */}
            </Box>
          </QuickGrid>
        </Content>
      </Wrapper>
    </>
  );
};

export default SummerInfoPage;
